export function isScannerEntry(pathname, search) {
  if (pathname !== '/') return false;
  const params = new URLSearchParams(search);
  return !params.toString() || params.get('session_expired') === 'true';
}

export function isSessionExpiredEntry(search) {
  return new URLSearchParams(search).get('session_expired') === 'true';
}
